import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { phaseTypeSchema } from './phase-type';

export type UpdatePhasePayload = z.output<typeof updatePhasePayloadSchema>;
export type UpdatePhasePayloadDTO = z.input<typeof updatePhasePayloadSchema>;

export const updatePhasePayloadSchema = z.object({
  end: isoDatetimeToDate.optional(),
  start: isoDatetimeToDate.optional(),
  typeIds: z.array(phaseTypeSchema.shape.id).optional(),
});
